export default __webpack_public_path__ + "static/guma-a90579c380e4cb610ed6a1298647f7ef.jpg";